import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Table, Modal, message, Divider } from "antd";
import { DownloadOutlined, PlusOutlined } from '@ant-design/icons';
import StationApi from '@api/station'
import SearchForm from '@components/SearchForm'
import Title from '@/components/Title'
import { connect } from 'react-redux'
import { setStateSearchParams } from '@store/actions/common'
import './style.css'


const Pages = ({ history, userInfo, searchArgs, dispatch }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [deleteVisible, setDelVisible] = useState(false)
  const [params, setParams] = useState({}) // 暂存每一列的数据
  const [totalData, setTotalData] = useState({})
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  })


  // 搜索
  const [inputList] = useState([{
    name: "name",
    message: "请输入站点名称",
    span: 4,
  }])

  useEffect(() => {
    listByPageStation()
    return () => { }
  }, [searchParams])
  useEffect(() => {
    statistics()
    return () => {
    }
  }, [])



  const listByPageStation = () => {
    setLoading(true)
    const statinIds = userInfo.stationIds ? userInfo.stationIds.split(",") : []
    StationApi.listByPageStation({ ...searchParams, stationIds: statinIds }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setData(res.data.data)
      }
    })
  }

  const statistics = () => {
    const statinIds = userInfo.stationIds ? userInfo.stationIds.split(",") : []
    StationApi.statistics({ stationIds: statinIds }).then((res) => {
      if (res.status == 0 && res.data) {
        setTotalData(res.data)
      }
    })
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
    }
    setSearchParams(params)

  }

  const getMonths = (date1, date2) => {
    if (date1 && date2) {
      date1 = date1.split("-");
      date2 = date2.split("-");
      var year1 = parseInt(date1[0]),
        year2 = parseInt(date2[0]),
        years = year2 - year1
      return years + '年';
    }
  }
  /**
   * 重置
   */

  /**
   *
   * @param obj
   * 更新数据
   */
  const detail = (obj, tag) => {
    dispatch(setStateSearchParams({ ...searchParams, path: history.location.pathname }))
    sessionStorage.setItem('obj', JSON.stringify(obj))
    history.push(`/systemSeting/station/addstation?id=${obj.id}&tag=${tag}`)
  }

  /**
   * table配置
   * @type {*[]}
   */


  const columns = [
    {
      title: '厂站名',
      dataIndex: 'name',
      align: 'center',
      key: 'name',
      width: 180
    },
    {
      title: '厂站简称',
      dataIndex: 'aliasName',
      align: 'center',
      key: 'aliasName',
      width: 180
    },
    {
      title: '厂站地址',
      dataIndex: 'addr',
      key: 'admRegion',
      align: 'center',
      width: 380
    },
    {
      title: '厂站工艺',
      dataIndex: 'treatProcess',
      key: 'addr',
      align: 'center',
      width: 140,
      //render: text => Pover(text, 7)
    },
    {
      title: '设计方量',
      dataIndex: 'designProc',
      key: 'status',
      align: 'center',
      width: 140,
      // render: text => {
      //     return text == 1 ? "拟建" : (text == 2 ? "在建" : "运营中")
      // }
    },
    {
      title: '负责人',
      dataIndex: 'opeLeader',
      align: 'center',
      key: 'watershed',
      width: 150,

    },
    {
      title: '创建时间',
      dataIndex: 'createAt',
      align: 'center',
      key: 'rive',
      width: 150,
      render: (obj) => {
        if (obj) {
          return (
            obj.slice(0, 10)
          )
        }

      }
    },
    {
      title: '到期时间',
      dataIndex: 'serviceTime',
      align: 'center',
      key: 'comDepart',
      width: 150,

    },
    {
      title: '期限',
      align: 'center',
      key: 'opeDepart',
      width: 140,
      render: (obj) => {
        return (
          <span>
            {
              getMonths(obj.createAt, obj.serviceTime)
            }
          </span>)
      }
    },
    {
      title: '状态',
      key: 'operation',
      align: 'center',
      dataIndex: 'status',
      width: 180,
      render: (obj) => {

        return (
          <span className={`${obj == 0 ? 'greenMark' : obj == 1 ? 'redMark' : obj == 2 ? 'blueMark' : ''}`}>
            {
              obj == 0 ? <i className='iconfont iconzhengchang'>  正常</i> :
                obj == 1 ? <i className='iconfont iconqianfei'>  欠费</i> :
                  obj == 2 ? <i className='iconfont icontingyong'>  停用</i> : ''
            }
          </span>
        )
      }
      // render: (obj) => {
      //     return (
      // 		<span className={`${obj == 0 ? 'greenMark': obj== 1 ? 'redMark' : obj == 2 ? 'blueMark' : ''}`}>
      // 			{
      // 				obj==0 ? '正常' : obj==1 ? '欠费' : obj==2 ? '停用' : ''
      // 			}
      // 		</span>)
      // }
    }
  ]

  const deleteStation = (obj) => {
    setDelVisible(true)
    setParams(obj)
  }

  /**
  * 删除规则
  */
  const deletes = () => {
    StationApi.deleteStationByIdDevice({ id: params.id }).then(res => {
      if (res.status == 0) {
        setDelVisible(false)
        getListByPage()
        message.success("删除成功！")
      }
    })
  }

  const cancel = () => {
    setDelVisible(false)
    setParams({})
  }

  const btnList = [{
    title: "新增",
    style: {
      background: "#31d5df",
      color: "#fff",
      border: "1px solid #31d5df"
    },
    icon: <PlusOutlined />,
    onClick: () => {
      history.push("/systemSeting/station/addstation")
    }
  }, {
    title: "导出",
    style: {
      background: "#31d5df",
      color: "#fff",
      border: "1px solid #31d5df"
    },
    icon: <DownloadOutlined />,
    onClick: () => {
      StationApi.batchExport({ ...searchParams }).then(res => {
        let a = document.createElement('a');
        let blob = new Blob([res], { type: "application/vnd.ms-excel" });
        let objectUrl = URL.createObjectURL(blob);
        a.setAttribute("href", objectUrl);
        a.setAttribute("download", '站点列表.xls');
        a.click();
      })
    }
  }]

  return (
    <div className='baseContent boundary'>
      <div className='col'>
        <div className='cols'>
          <div className='colss'>
            <p className='p'><i className='iconfont iconicon_nav_changzhanguanli_act'>&nbsp;&nbsp;</i>厂站总数</p>
          </div>
          <div className='colss'><h1>{totalData.totalCount}</h1></div>
          <div className='colss'>
            <ul>
              <li >正常<p>{totalData.normalCount}</p></li>
              <li >欠费<p>{totalData.arrearageCount}</p></li>
              <li >停用<p>{totalData.disabledCount}</p></li>
            </ul>
          </div>
        </div>
        <div style={{ width: '1px', height: '154px', background: '#EEF0F3' }}></div>
        <div className='cols'>
          <div className='colss'>
            <p className='p'><i className='iconfont iconicon_gongyidanyuan_yanyangchi_32'>&nbsp;&nbsp;</i>总设计方量</p>
          </div>
          <div className='colss'><h1>{totalData.totalDesignProc}</h1></div>
          <div className='colss'>
            <ul>
              <li >正常<p>{totalData.normalDesignProc}</p></li>
              <li >欠费<p>{totalData.arrearageDesignProc}</p></li>
              <li >停用<p>{totalData.disabledDesignProc}</p></li>
            </ul>
          </div>
        </div>
      </div>
      <div className='title'>
        <Title title="站点列表" style={{ marginLeft: '24px' }}></Title>
        <div style={{ marginLeft: '24px' }}>
          <SearchForm searchParams={searchParams} span={6} inputList={inputList} onSearch={search} />
        </div>
        {/*<HandleButton btnList={btnList} btnStyle={{ justifyContent: "space-between" }} />*/}

        <div >
          <Table
            className='Table'
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={{
              current: data.pageNum,
              pageSize: data.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: data.total
            }}
            onChange={handleTableChange}
            loading={loading}
            onRow={(record) => ({
              onClick: () => {
                detail(record, "edit")
              }
            })}
          />
        </div>

        {
          deleteVisible &&
          <Modal
            title='删除站点'
            width={420}
            open={deleteVisible}
            onCancel={cancel}
            onOk={deletes}>
            <div style={{ textAlign: 'center', color: "red" }}>
              <p>{`确定要删除站点【${params.name}】吗？`}</p>
            </div>
          </Modal>
        }
      </div>
    </div >
  )
}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
};

export default connect(mapStateToProps)(Pages)
